import { getIdentifier, getTitle as defaultGetTitle } from "@/utils/generators/data";
export const clickHandler = (setData, useOffset, event, fixed, id, options, onChange, getTitle, searchable, onlyKey, className, searchFilter)=>{
    event.stopPropagation();
    event.preventDefault();
    setData({
        id,
        useOffset,
        options,
        onChange,
        fixed,
        searchable,
        className,
        onlyKey,
        getTitle,
        open: true,
        searchFilter
    });
};
export const getValue = function(value, options) {
    let getTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultGetTitle, onlyKey = arguments.length > 3 ? arguments[3] : void 0, T = arguments.length > 4 ? arguments[4] : void 0;
    if (value || Number.isInteger(value)) {
        // constants
        const valueTitle = value && getTitle(onlyKey ? options.find((el)=>getIdentifier(el) === value) : value);
        return T.has(valueTitle) ? T(valueTitle) : valueTitle;
    }
};
export const clearValue = (event, onChange)=>{
    event.stopPropagation();
    event.preventDefault();
    onChange(null);
};
